<template>
	<div class="wrapper">
		<div v-if="loading && officeList.length === 0" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<template v-slot:header>
							<i class="icon-pencil"></i> Download Archived Report
						</template>
						<b-card-body>
							<b-form>
								<b-form-group
									label="Select Office"
									label-for="office-list"
									:label-cols="3"
									:horizontal="true"
									label-class="required">
									<model-select
										id="office-list"
										:options="officeList"
										v-model="selectedOfficeId"
										placeholder="Please Select">
									</model-select>
								</b-form-group>

								<b-form-group
									label="Select Report Type"
									label-for="reportType"
									:label-cols="3"
									:horizontal="true"
									label-class="required">
									<b-form-select v-model="selectedReportType"
																 name="reportType"
																 id="reportType"
																 :plain="true"
																 :options="reportTypeDropDownList"
																 value="1">
									</b-form-select>
								</b-form-group>

								<b-form-group
									label="Select File Type"
									label-for="fileType"
									:label-cols="3"
									:horizontal="true"
									label-class="required">
									<b-form-select v-model="selectedFileType"
																 name="fileType"
																 id="fileType"
																 :plain="true"
																 :options="fileTypeDropDownList"
																 value="1">
									</b-form-select>
								</b-form-group>

								<b-form-group
									v-if="selectedReportType !== 2 && selectedReportType !== 3"
									label="Date Range" label-for="dateRangePicker"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<date-range-picker
										ref="picker"
										:opens="dateRangePickerAlignment"
										:locale-data="localeData"
										:maxDate="maxDate"
										:singleDatePicker="false"
										:timePicker="false"
										:timePicker24Hour="false"
										:showWeekNumbers="false"
										:showDropdowns="true"
										:autoApply="false"
										v-model="reportDateRange"
										:linkedCalendars="true"
									>
										<template v-slot:input="picker" style="min-width: 350px;">
											{{ picker.startDate | date }} - {{ picker.endDate | date }}
										</template>
									</date-range-picker>
								</b-form-group>

								<b-form-group
									v-if="selectedReportType === 2 || selectedReportType === 3"
									label="Select Month"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<month-picker
										@change="showMonthPickerDate"
										:show-year="true"
										:editable-year="true"
										:max-date="maxDate"
										:no-default="true"
										:clearable="true">
									</month-picker>
								</b-form-group>

								<b-form-group
									label="HRM Email"
									label-for="email"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="email" name="email" id="email" type="email" placeholder="Email"></b-form-input>
								</b-form-group>

								<b-form-group
									label="HRM Password"
									label-for="password"
									label-class="required"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="password" name="password" id="password" type="password" placeholder="Password" autocomplete="new-password"></b-form-input>
								</b-form-group>

								<div class="form-actions">
									<b-button v-if="!disableSubmission" v-on:click="validateForm()" variant="primary">
										<i class="fa fa-clone"></i> Download
									</b-button>
									<b-button v-else variant="primary" disabled>
										<b-spinner small></b-spinner>
										Please Wait...
									</b-button>
								</div>
							</b-form>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import officeService from "@/services/officeService";
import toastService from '@/services/toastService';
import {ModelSelect} from "vue-search-select";
import DateRangePicker from 'vue2-daterange-picker';
import { MonthPicker } from 'vue-month-picker';
import customerSupportService from "@/services/customerSupportService";


export default {
	name: "ArchivedReportDownload",
	components : {
		ModelSelect,
		DateRangePicker,
		MonthPicker
	},
	data : function () {
		return {
			loading : false,
			disableSubmission : false,
			officeList : [],
			officeIdToName : {},
			selectedOfficeId : null,
			selectedReportType : 1,
			selectedFileType : 1,
			email : null,
			password : null,
			reportDateRange : {
				startDate : new Date(),
				endDate : new Date(),
			},
			reportTypeDropDownList: [
				{text: "Detailed Report", value: 1},
				{text: "Horizontal Monthly Report", value: 2},
				{text: "Vertical Monthly Report", value: 3},
				{text: "Overtime Report", value: 4}
			],
			fileTypeDropDownList: [
				{text: "Excel", value: 1},
				{text: "PDF", value : 2}
			],
			maxDate : new Date(),
			localeData: {
				direction: 'ltr',
				format: 'dd-mm-yyyy',
				separator: ' - ',
				applyLabel: 'Apply',
				cancelLabel: 'Cancel',
				weekLabel: 'W',
				customRangeLabel: 'Custom Range',
				daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
				monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				firstDay: 0
			},
			dateRangePickerAlignment : "right",
			monthPickerDate: {
				from: null,
				to: null,
				month: null,
				year: null
			}
		};
	},
	filters: {
		date(val) {
			return val.toLocaleString("en-GB", {
				day: "numeric",
				month: "short",
				year: "numeric"
			});
		}
	},
	methods : {
		getOfficeList : function () {
			officeService.getOfficeList( r => {
				this.officeList = this.createOfficeDropDownList(r);
				this.loading = false;
			});
		},
		createOfficeDropDownList: function (data) {
			let officeList = [ {text: 'Please select', value: null} ];
			data.forEach((value, index) => {
				let office = new Object();
				office.text = value.name;
				office.value = value.id;
				officeList.push(office);
				this.officeIdToName[value.id] = value.name.replaceAll(" ", "-");
			});

			return officeList;
		},
		validateForm: function() {
			if(this.selectedOfficeId == null) return toastService.showErrorToast("No office is selected.");
			if((this.selectedReportType === 1 && this.selectedFileType === 2)
				|| (this.selectedReportType === 3 && this.selectedFileType === 1))
				return toastService.showErrorToast("Selected file type is not supported.");
			if(this.email == null || this.email.trim() === "") return toastService.showErrorToast("HRM email is not provided.");
			if(this.password == null || this.password.trim() === "") return toastService.showErrorToast("HRM password is not provided.");
			if(this.selectedReportType === 2 || this.selectedReportType === 3) {
				if(this.monthPickerDate.from == null || this.monthPickerDate.to == null)
					return toastService.showErrorToast("No month is selected.");
			}

			this.submitForm();
		},
		submitForm : function() {
			this.disableSubmission = true;
			if(this.selectedReportType !== 2 && this.selectedReportType !== 3) {
				this.reportDateRange.startDate = this.reportDateRange.startDate.setHours(0,0,0,0);
				this.reportDateRange.endDate = this.reportDateRange.endDate.setHours(0,0,0,0);
			}

			let formData = {
				officeId: this.selectedOfficeId,
				reportType: this.selectedReportType,
				fileType: this.selectedFileType,
				email: this.email,
				password: this.password,
				startDate: (this.selectedReportType !== 2 && this.selectedReportType !== 3) ? this.reportDateRange.startDate : this.monthPickerDate.from.getTime(),
				endDate: (this.selectedReportType !== 2 && this.selectedReportType !== 3) ? this.reportDateRange.endDate : this.monthPickerDate.to.getTime()
			};


			customerSupportService.downloadArchivedReport(formData, this.generateFileName(formData), this.serveFile, (error) => {
				toastService.showErrorToast("Request failed "+ error);
			}).finally(() => {
				this.disableSubmission = false;
			});

		},
		serveFile(response, fileName) {
			let fileURL = window.URL.createObjectURL(new Blob([response.data]));
			let fileLink = document.createElement('a');

			fileLink.href = fileURL;
			fileLink.setAttribute('download', fileName);
			document.body.appendChild(fileLink);

			fileLink.click();
			toastService.showSuccessToast("Report downloaded");
			this.resetForm();
		},
		showMonthPickerDate (date) {
			this.monthPickerDate = date
		},
		generateFileName: function (formData) {
			let fileName = this.officeIdToName[formData.officeId] + "-";
			switch (this.selectedReportType) {
				case 1:
					fileName = fileName.concat("detailed-report");
					break;
				case 2:
					fileName = fileName.concat("horizontal-monthly-report-", this.monthPickerDate.month);
					break;
				case 3:
					fileName = fileName.concat("vertical-monthly-report-", this.monthPickerDate.month);
					break;
				case 4:
					fileName = fileName.concat("overtime-report");
					break;
			}
			switch (this.selectedFileType) {
				case 1:
					fileName = fileName.concat(".xlsx");
					break;
				case 2:
					fileName = fileName.concat(".pdf");
					break;
			}

			return fileName;
		},
		resetForm() {
			this.selectedOfficeId = null;
			this.selectedReportType = 1;
			this.selectedFileType = 1;
			this.email = null;
			this.password = null;
			this.reportDateRange = {
				startDate : new Date(),
				endDate : new Date(),
			};
			this.monthPickerDate = {
				from: null,
				to: null,
				month: null,
				year: null
			};
		}
	},
	created() {
		this.loading = true;
		this.getOfficeList()
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
<style src="vue2-daterange-picker/dist/vue2-daterange-picker.css"></style>
